const defaultConfig = {
  REDUX_ACTION_NAMESPACE: '__activity',
  AUTH_CLIENT_ID: 'AUTH_CLIENT_ID'
}

export default defaultConfig
